import { HttpMethod } from '@teqplay/api'

import { requestBuilder } from '../builder'
import { TRecipient } from './vesselJourney'

// Core notification object
export type TNotification = {
  _id: string
  imo: string
  portId?: string
  portUnlocode: string
  portName?: string
  eventType: string
  mediums: ('WHATSAPP' | 'EMAIL')[]
  locationId?: string
  locationName?: string
  durationBeforeEvent?: string
  sharedRecipients: TRecipient[]
}

export type TGetNotificationInput = { imo: string; unlocode: string }
export type TGetNotificationOutput = TNotification[]

const get = requestBuilder
  .type<TGetNotificationInput, TGetNotificationOutput>()
  .request(({ input: { imo, unlocode } }) => {
    const params = new URLSearchParams({ imo, unlocode })
    return {
      path: `/v1/notification?${params.toString()}`,
      method: HttpMethod.GET
    }
  })

export type TPostNotificationInput = {
  notification: Omit<TNotification, '_id'>
  returnFinalNotificationList?: boolean
}
export type TPostNotificationOutput = Omit<TNotification, '_id'>[]

const post = requestBuilder
  .type<TPostNotificationInput, TPostNotificationOutput>()
  .request(({ input: { notification } }) => {
    const params = new URLSearchParams()
    const query = params.toString()
    return {
      path: `/v1/notification${query ? `?${query}` : ''}`,
      method: HttpMethod.POST,
      init: {
        body: JSON.stringify(notification)
      }
    }
  })

export type TPutNotificationInput = {
  id: string
  notification: Omit<TNotification, '_id'>
  returnFinalNotificationList?: boolean
}
export type TPutNotificationOutput = TNotification[]

const put = requestBuilder
  .type<TPutNotificationInput, TPutNotificationOutput>()
  .request(({ input: { id, notification, returnFinalNotificationList } }) => {
    const params = new URLSearchParams()
    if (returnFinalNotificationList !== undefined) {
      params.set('returnFinalNotificationList', returnFinalNotificationList.toString())
    }
    const query = params.toString()
    return {
      path: `/v1/notification/${id}${query ? `?${query}` : ''}`,
      method: HttpMethod.PUT,
      init: {
        body: JSON.stringify(notification)
      }
    }
  })

export type TDeleteNotificationInput = {
  id: string[]
  returnFinalNotificationList?: boolean
}
export type TDeleteNotificationOutput = TNotification[]

const del = requestBuilder
  .type<TDeleteNotificationInput, TDeleteNotificationOutput>()
  .request(({ input: { id, returnFinalNotificationList } }) => {
    const params = new URLSearchParams()
    if (returnFinalNotificationList !== undefined) {
      params.set('returnFinalNotificationList', returnFinalNotificationList.toString())
    }

    const query = params.toString()
    return {
      path: `/v1/notification${query ? `?${query}` : ''}`,
      method: HttpMethod.DELETE,
      init: {
        body: JSON.stringify(id)
      }
    }
  })

const notification = { get, post, put, delete: del }
export default notification
